import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(["idWorldProjectCategory"]),
        getByWork: state => workId => {
          return state.objs.filter(pc => pc.work === workId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(["idWorldProjectCategory"]),
    },
    actions: {
        ...functions.createDefaultActionsWithStore(["idWorldProjectCategory"]),
    },
}